import { useIndexStore } from "~/stores";

// Desktop (> 992px, the CSS breakpoint where the sidebar stops being a drawer)
// starts with the sidebar expanded and keeps it that way across navigation and
// reloads unless the user collapsed it. Mobile/tablet keep the drawer behaviour.
const DESKTOP_QUERY = "(min-width: 993px)";

export default defineNuxtPlugin(() => {
	const store = useIndexStore();

	// The server cannot measure the viewport, so it goes by the client hints / UA.
	// The client re-checks with matchMedia before anything is shown to the user.
	const isDesktop = import.meta.server
		? (() => {
				const h = useRequestHeaders(["user-agent", "sec-ch-ua-mobile"]);
				return h["sec-ch-ua-mobile"] !== "?1" && !/Mobi|Android|iPhone|iPad/i.test(h["user-agent"] ?? "");
			})()
		: window.matchMedia(DESKTOP_QUERY).matches;

	if (isDesktop) store.isSidebarOpened = !store.sidebarDesktopCollapsed;

	if (import.meta.client) {
		const mq = window.matchMedia(DESKTOP_QUERY);
		mq.addEventListener("change", (e) => {
			store.isSidebarOpened = e.matches ? !store.sidebarDesktopCollapsed : false;
		});
		// Only the user's own toggle reaches here on desktop: nothing else closes it there.
		watch(
			() => store.isSidebarOpened,
			(open) => {
				if (mq.matches) store.sidebarDesktopCollapsed = !open;
			},
		);

		// Collapsed rail: show the item's label on hover (native tooltip, no layout cost).
		document.addEventListener("mouseover", (e) => {
			const link = (e.target as HTMLElement | null)?.closest?.(".sidebar:not(.open) .menus__item__option") as HTMLElement | null;
			if (!link || link.title) return;
			const label = link.querySelector("span")?.textContent?.trim();
			if (label) link.title = label;
		});
	}
});
